export const PAGE_TITLE = 'Overview';
export const BREADCRUMB_LINKS = [{ label: PAGE_TITLE }];

export const OFFER_PERFORMANCE_BEFORE_PARAM = 'offer-performance-before';
export const OFFER_PERFORMANCE_AFTER_PARAM = 'offer-performance-after';
export const OFFER_PERFORMANCE_SORT_FIELD = 'offer-performance-sortField';
export const OFFER_PERFORMANCE_SORT_DIRECTION = 'offer-performance-sortDirection';
export const OFFER_PERFORMANCE_DEFAULT_PAGE_SIZE = 5;
